$( document ).on("turbo:load", function(){

  function populateVariants(duplicate, variant_selector, variants) {
    var app = $('#node_app_id :selected').val();
    var options = $(variants).filter(`optgroup[label='${app}']`).html();
    duplicate.parent().show()
    if (options) {
      variant_selector.html(options)
      variant_selector.parent().show();
      var currentVariant = $('#current_variant_id').val()
      if (currentVariant != $('#node_variant_id :selected').val()) {
        duplicate.parent().hide()
      }
    } else {
      variant_selector.empty();
      variant_selector.parent().hide();
    }
  }

  if ($('#duplicate-modal').length > 0) {
    var variant_selector = $('#node_variant_id')
    var parent_selector = $('#node_parent_id');
    var variants = variant_selector.html();
    var parents = parent_selector.html();
    var duplicate = $('#node_is_duplicate')

    variant_selector.parent().hide();
    parent_selector.parent().hide();
    populateVariants(duplicate, variant_selector, variants)
    populateParents(parents, parent_selector)

    $('#node_app_id').on('change', function () {
      populateVariants(duplicate, variant_selector, variants)
      populateParents(parents, parent_selector)
    });

    variant_selector.on('change', function () {
      var currentVariant = $('#current_variant_id').val()
      if (currentVariant != $('#node_variant_id :selected').val()) {
        duplicate.parent().hide()
      } else {
        duplicate.parent().show()
      }
      populateParents(parents, parent_selector);
    });
  }

});

function populateParents(parents, parent_selector) {
  var variant = $('#node_variant_id :selected').val();
  $.ajax({
    url: "/admin/nodes",
    method: "GET",
    dataType: "json",
    data: {variant_id: variant},
    error: function (xhr, status, error) {
      console.error('AJAX Error: ' + status + error);
    },
    success: function (response) {
      var nodes = response["nodes"];
      parent_selector.empty();
      if (nodes) {
        for(var i = 0; i < nodes.length; i++){
          parent_selector.append('<option value="' + nodes[i]["id"] + '">' +nodes[i]["name"] + '</option>');
        }
        parent_selector.parent().show();
      } else {
        parent_selector.empty();
        parent_selector.parent().hide();
      }
    }
  });
}
